import { ErrorType } from "../../../models/HttpError";

// store
import * as ProtocolPatientsStore from "../../../redux/middleware/ProtocolPatientsMiddleware";
import { AppState } from "../../../redux/reducers";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

interface ConnectedProps {
  isGenerating: boolean;
  isGeneratedSuccessfully: boolean;
  failOnGenerating: boolean | undefined;
  error: ErrorType | undefined;
  FileBlob: Blob | null;
}

interface DispatchProps {
  ExportDerivedPatientsToExcel: typeof ProtocolPatientsStore.ActionCreators.ExportDerivedPatientsToExcel;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isGenerating: state.ProtocolPatients?.isLoading,
    isGeneratedSuccessfully: state.ProtocolPatients?.isGeneratedSuccessfully,
    failOnGenerating: state.ProtocolPatients?.failOnGenerating || false,
    error: state.ProtocolPatients?.error,
    FileBlob: state.ProtocolPatients?.excelBlob || null
});

export const mapDispatchToProps = {
  ...ProtocolPatientsStore.ActionCreators
};
